import React from "react";
import { NavLink } from "react-router-dom"; // Use NavLink instead of Link
import "../../styles/FooterBar.css";
import { motion } from "framer-motion";
import { IoFastFoodOutline } from "react-icons/io5";
import { CiShop } from "react-icons/ci";
import { SlHandbag } from "react-icons/sl";
import { GiAutoRepair } from "react-icons/gi";
import { LocalStorageUtils } from "utils/localstorage.utils";
import { AREA, CUSTOMER_PRODUCT, UI_TAB_LIST } from "utils/constants";
import { GiSellCard } from "react-icons/gi";
import { FaSuitcase } from "react-icons/fa";
import { isShowCustomerProductPage } from "utils/helper";

function FooterBar() {
  const uiTabList = LocalStorageUtils.getUiTabList() ?? UI_TAB_LIST;
  const foodTab = uiTabList.find(
    (tab) => tab.type === AREA.EXTRA_DETAILS.UI.TAB.TYPE.Food
  );
  const productTab = uiTabList.find(
    (tab) => tab.type === AREA.EXTRA_DETAILS.UI.TAB.TYPE.Grocery_Product
  );
  const shopTab = uiTabList.find(
    (tab) => tab.type === AREA.EXTRA_DETAILS.UI.TAB.TYPE.Merchant
  );
  const serviceTab = uiTabList.find(
    (tab) => tab.type === AREA.EXTRA_DETAILS.UI.TAB.TYPE.Service
  );

  const customerProductTab = uiTabList.find(
    (tab) => tab.type === AREA.EXTRA_DETAILS.UI.TAB.TYPE.Customer_Product
  );

  const jobTab = uiTabList.find(
    (tab) => tab.type === AREA.EXTRA_DETAILS.UI.TAB.TYPE.Customer_Product_Job
  );

  const FooterBarItem = ({ to, icon, text }) => {
    return (
      <NavLink to={to} className="footer-link" activeclassname="active">
        <motion.div
          className="footer-icon"
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
        >
          {icon}
        </motion.div>
        <motion.span
          className="footer-text"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.3 }}
        >
          {text}
        </motion.span>
      </NavLink>
    );
  };

  return (
    <div className="footer-bar">
      {foodTab &&
        foodTab.status === AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active && (
          <FooterBarItem
            to="/"
            icon={<IoFastFoodOutline size={23} />}
            text="Food"
          />
        )}
      {productTab &&
        productTab.status === AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active && (
          <FooterBarItem
            to="/products"
            icon={<SlHandbag size={23} />}
            text="Products"
          />
        )}
      {shopTab &&
        shopTab.status === AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active && (
          <FooterBarItem to="/shops" icon={<CiShop size={23} />} text="Shops" />
        )}

      {serviceTab &&
        serviceTab.status === AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active && (
          <FooterBarItem
            to="/service"
            icon={<GiAutoRepair size={23} />}
            text="Service"
          />
        )}
      {jobTab && jobTab.status === AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active && (
        <FooterBarItem
          to={`/customer-products/${CUSTOMER_PRODUCT.POST_TYPE.JOB}`}
          icon={<FaSuitcase size={23} />}
          text="Jobs"
        />
      )}

      {customerProductTab &&
        customerProductTab.status === AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active &&
        isShowCustomerProductPage() && (
          <FooterBarItem
            to={`/customer-products/${CUSTOMER_PRODUCT.POST_TYPE.PRODUCT}`}
            icon={<GiSellCard size={23} />}
            text="ReSell"
          />
        )}
    </div>
  );
}

export default FooterBar;
